/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

// Mixins
import datepickerMixin from 'shared/ui/mixins/widgets/datepicker';

/**
 * Base component to wrap dates inputs with a common markup.
 *
 * It has all `BaseControl` options plus:
 *
 * @vue-prop {String} [type="date"] the type of the input
 *
 * @example
 *
 * datetime-picker(:label="t('name')" type="text" v-model="form.name" validations="required" name="name")
 *
 * @category ui.components.form-elements.pickers
 * @exports DatetimePicker
 */
const __vue_script__ = {
    name: 'DatetimePicker',

    extends: BaseControl,

    mixins: [datepickerMixin],

    props: {

        timezone: {
            type: String,
            default: Intl.DateTimeFormat().resolvedOptions().timeZone
        },

        timePickerOptions: {
            type: [Object, Function],
            default: () => null,
        },
    },

    data() {
        return {
            // This won't work with vue 3. -> used in the scheduled email modal.
            open: false
        };
    },

    methods: {
        /**
         * Tries to grab the focus on the input element
         */
        attemptFocus() {
            const picker = this.$refs.picker;

            if (this.focused && picker) {
                picker.$refs.input.focus();
            }
        },

        /**
         * Method used to close the date picker
         */
        close() {
            this.open = false;
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{class:{'with-actions': Boolean(_vm.$scopedSlots.actions)},attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"uid":_vm.uid,"errors":_vm.errors,"hint-after-label":_vm.hintAfterLabel,"warning":_vm.warning,"dependant":_vm.dependant}},[_c('date-picker',_vm._g(_vm._b({ref:"picker",staticClass:"date-picker form-control",class:{'has-error': _vm.errors.length, 'has-warning': _vm.warning},attrs:{"append-to-body":true,"disabled-date":_vm.disabledDate,"disabled-time":_vm.disabledTime,"first-day-of-week":_vm.firstDayOfWeek,"time-picker-options":_vm.timePickerOptions,"format":_vm.dateTimeFormat,"input-attr":{id: _vm.uid},"lang":_vm.$i18n.locale,"name":_vm.name,"open":_vm.open,"placeholder":_vm.dateTimeFormat,"range-separator":" - "},on:{"update:open":function($event){_vm.open=$event}},scopedSlots:_vm._u([{key:"calendar-icon",fn:function(ref){return [_c('i',{staticClass:"ic-calendar"})]}},{key:"mx-clear-icon",fn:function(ref){return [_c('i',{staticClass:"ic-x"})]}}]),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'date-picker',_vm.attrs,false),_vm.listeners)),_vm._t("actions")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DatetimePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__